export const RECEIVER_WALLET = "UQC9i8JvMUyYnC7zdUb_LM3iH2iY6g0ZqZgjrIR4OwDiYTRB";
export const ISLAND_COST = 250; // TON
export const BUINK_USD_RATE = 0.1; // 0.1 USD = 1 Buink
export const BUINK_DISCOUNT = 0.3; // 30% discount
export const ISLAND_COST_BUINK = 2500;

export const FLYING_LAND_SIZE = 64;

export const RARITY_ORDER = ["common", "uncommon", "rare", "epic", "legendary"];

export const BLOCK_ID_TO_TYPE = [
    "grass",
    "dirt",
    "stone",
    "coal_ore",
    "iron_ore",
    "tree_top",
    "leave",
    "sand",
    "cloud",
    "snow",
    "jungle_tree",
    "jungle_leaves",
    "cactus",
    "jungle_grass",
    "lava",
    "frost_mint",
];
